var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yeti-toast"},[_c('h2',{staticClass:"title is-6"},[_vm._t("title")],2),_vm._v(" "),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }